<template>
  <div class="payments">
    <a-spin :spinning="spinning">
      <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
        <svg class="icon" aria-hidden="true" style="fill: #fff">
          <use xlink:href="#icon-yinhangka"></use>
        </svg>
      </breadcrumbs>
      <div class="content">
        <p class="overview">Overview</p>
        <tags
          :billingsAgg="billingsAgg"
        />
        <p class="history">Payment History</p>
        <filterCont
          :params="params"
          :getData="getData"
          :setParams="setParams"
        />
        <tableContent
          :params="params"
          :dataList="list"
          :getList="getData"
          :listTotal="listTotal"
          :setDetailData="setDetailData"
        />
      </div>
    </a-spin>
    <invoiceModal
      :setDetailData="setDetailData"
      :detailData="detailData"
      v-if="detailData.type === 'invoice'"
    />
    <detailModal
      :setDetailData="setDetailData"
      :detailData="detailData"
      :marketplace="params.marketplace"
      v-if="detailData.type === 'detail'&&detailData.billingType !== 'MANUAL'"
    />
    <manualDetailModal
      :setDetailData="setDetailData"
      :detailData="detailData"
       :marketplace="params.marketplace"
     v-if="detailData.type === 'detail'&&detailData.billingType === 'MANUAL'"
    />
  </div>
</template>
<script setup>
  import { ref, onMounted, watch } from "vue";
  import { financePublisherApi } from "~/server";
  import filterCont from './filterCont';
  import breadcrumbs from "~/pages/seller/breadcrumbs.vue";
  import tableContent from './tableContent';
  import detailModal from './detailModal';
  import manualDetailModal from './manualDetailModal';
  import invoiceModal from './invoiceModal';
  import tags from './tags';
  import moment from 'moment';

  const breadcrumbsData = {
    title: "Payments",
    color:'rgba(250, 172, 38, 1)',
    links: [
      {
        name: "Home",
        path: "/publisher/dashboard",
      },
      {
        name: "Finance",
        path: "/publisher/finance/payments",
      },
      {
        name: "Payments",
        path: "/publisher/finance/payments",
      },
    ],
  };

  const detailData = ref({});
  const spinning = ref(false);
  const list = ref([]);
  const listTotal = ref(0);
  const billingsAgg = ref({
    currencySymbol: '',
    totalCommissionPaid: '',
    totalLifetimeEarnings: '',
    totalOpenEarnings: '',
    totalPendingPayment: '',
    totalAttributionOpenEarnings: '',
    totalAssociateOpenEarnings: '',
  })
  const params = ref({
    marketplace: "amazon.com",
    page: 1,
    size: 10,
  });

  const setDetailData = (data, type, reload) => {
    const newData = {...data};
    if (data.billingId) {
      newData.type = type;
    }
    detailData.value = newData;
    if (reload) {
      getData();
    }
  }

  watch([() => params.value.marketplace],
    () => {
      getData();
  })

  const setParams = data => {
    if (data) {
      params.value = data;
    } else {
      params.value = {
        marketplace: "amazon.com",
        startBillingDateStr: moment().subtract(31, "day").valueOf(),
        endBillingDateStr: moment().valueOf(),
        page: 1,
        size: 10,
        status: null,
        billingId: null
      };
      getData();
    }
  }

  const getData = async (newParams) => {
    spinning.value = true;
    if(newParams){
      params.value = {
        ...params.value,
        ...newParams,
      };
    }
    const aggRes = await financePublisherApi.getFinancePublisherBillingsAgg(params.value);
    const listRes = await financePublisherApi.getFinancePublisherBillingsList(params.value);
    if (listRes.success) {
      listTotal.value = listRes.data.total;
      list.value = listRes.data.data;
    }
    if (aggRes.success) {
      billingsAgg.value = aggRes.data;
    }
    spinning.value = false;
  };

  onMounted(() => {
    getData();
  })

</script>
<style lang="less" scoped>
  .payments {
    .content {
      padding: 16px;
      overflow: hidden;
      border-radius: 12px;
      background-color: var(--color-white);
      box-shadow: var(--section-box-shadow-6);
    }
    .history,
    .overview {
      font-weight: 600;
      font-size: 20px;
      color: var(--dark-1);
      letter-spacing: 0.5px;
      line-height: 28px;
    }
    .overview {

    }
    .history {
      margin-top: 32px;
    }
  }
</style>
